import { forwardRef, FunctionComponent } from 'react';
import type * as T from './SliderNavigation.types';
import * as s from './SliderNavigation.css';
import classNames from 'classnames';
import Button from '@media-ui/core/src/components/Button';
import { Icon16ChevronLeft } from '@vkontakte/icons';
export const SliderNavigationButton = forwardRef<HTMLButtonElement, T.ISliderNavigationButtonProps>((props, ref) => {
    const { direction = 'prev', className, onClick, isDisabled } = props;
    const ariaLabel = direction === 'prev' ? 'Назад' : 'Вперед';
    return (<Button ref={ref as React.RefObject<HTMLButtonElement>} className={classNames(s.button, className, s[`${direction}Direction`])} disabled={isDisabled} onClick={onClick} ariaLabel={ariaLabel} size="large" theme="light" iconOnly rounded dataQaDetail={direction === 'prev'
            ? 'SliderNavigationButtonPrev'
            : 'SliderNavigationButtonNext'}>
      <Icon16ChevronLeft width={24} height={24} fill="currentcolor"/>
    </Button>);
});
const SliderNavigation: FunctionComponent<T.ISliderNavigationProps> & {
    Button: typeof SliderNavigationButton;
} = (props) => {
    const { className, children } = props;
    return (<div className={classNames(s.root, className)} data-qa="SliderNavigation">
      {children}
    </div>);
};
SliderNavigationButton.displayName = 'SliderNavigationButton';
SliderNavigation.Button = SliderNavigationButton;
export default SliderNavigation;
